// extracted by mini-css-extract-plugin
module.exports = {"container":"logos_container__d2DrH","logo":"logos_logo__3Z_aV"};